import { GLOBAL_ACTION } from '../modules/GlobalActions';
import { UIState } from '../modules/Interface';

/* action type */
interface UIAction {
  type: string;
  payload: boolean;
}

/* defining the initial state with the data type */
const initialState: UIState = {
  overlay: false,
  curationHistory: false,
  curationSidebar: false,
  showCreateCampaignAsider: false,
  showCreateAssetSidebar: false,
  isStickyHeaderVisible: false,
  stickyOverlay: false,
  backOverlayForConfirm: false,
  backOverlayOnMainNav: false,
  backOverlayOnStickyHeader: false,
  closeCreateNewListAsiderCheck: false,
  articleSidebarPreviewInDetailProfile: false,
  detailProfileScrollCheck: false,
  articleDivScrollCheck: false,
  showAdvancedSearchSidebar: false,
  advancedSearch: false,
  advancedSearchCheck: false,
  emailCreatedCheck: false,
  applyAudienceFilterCheck: false,
  audienceFiltersApplied: false,
  isNewListAsiderOpen: false,
  closeCreateNewListAsiderFromCancelCheck: false,
  smallResolutionModal: false,
};

const uiReducer = (state = initialState, action: UIAction) => {
  const new_state = { ...state };

  switch (action.type) {
    case GLOBAL_ACTION.OPEN_OVERLAY:
      new_state.overlay = true;
      return new_state;
    case GLOBAL_ACTION.CLOSE_OVERLAY:
      new_state.overlay = false;
      return new_state;
    case GLOBAL_ACTION.BODY_BOL_FLAG:
      new_state.stickyOverlay = action.payload;
      return new_state;
    case GLOBAL_ACTION.OPEN_CURATION_HISTORY:
      new_state.curationHistory = true;
      return new_state;
    case GLOBAL_ACTION.CLOSE_CURATION_HISTORY:
      new_state.curationHistory = false;
      return new_state;
    case GLOBAL_ACTION.OPEN_CURATION_SIDEBAR:
      new_state.curationSidebar = true;
      return new_state;
    case GLOBAL_ACTION.CLOSE_CURATION_SIDEBAR:
      new_state.curationSidebar = false;
      return new_state;
    case GLOBAL_ACTION.OPEN_CREATE_ASSET_SIDEBAR:
      new_state.showCreateAssetSidebar = true;
      return new_state;
    case GLOBAL_ACTION.CLOSE_CREATE_ASSET_SIDEBAR:
      new_state.showCreateAssetSidebar = false;
      return new_state;
    case GLOBAL_ACTION.EMAIL_CREATED_CHECK:
      new_state.emailCreatedCheck = action.payload;
      return new_state;
    case GLOBAL_ACTION.OPEN_CREATE_NEW_CAMPAIGN_SIDEBAR:
      new_state.showCreateCampaignAsider = true;
      return new_state;
    case GLOBAL_ACTION.CLOSE_CREATE_NEW_CAMPAIGN_SIDEBAR:
      new_state.showCreateCampaignAsider = false;
      return new_state;
    case GLOBAL_ACTION.ENABLE_STICKY_HEADER:
      new_state.isStickyHeaderVisible = true;
      return new_state;
    case GLOBAL_ACTION.DISABLE_STICKY_HEADER:
      new_state.isStickyHeaderVisible = false;
      return new_state;
    case GLOBAL_ACTION.SET_CONFIRM_BACK_OVERLAY:
      new_state.backOverlayForConfirm = action.payload;
      return new_state;
    case GLOBAL_ACTION.SET_STICKY_HEADER_BACK_OVERLAY:
      new_state.backOverlayOnStickyHeader = action.payload;
      return new_state;
    case GLOBAL_ACTION.SET_MAIN_NAV_DARK_OVERLAY:
      new_state.backOverlayOnMainNav = action.payload;
      return new_state;
    case GLOBAL_ACTION.CLOSE_CREATE_NEW_LIST_ASIDER:
      new_state.closeCreateNewListAsiderCheck = !new_state.closeCreateNewListAsiderCheck;
      return new_state;
    case GLOBAL_ACTION.CLOSE_CREATE_NEW_LIST_ASIDER_FROM_CANCEL:
      new_state.closeCreateNewListAsiderFromCancelCheck = !new_state.closeCreateNewListAsiderFromCancelCheck;
      return new_state;
    case GLOBAL_ACTION.NEW_LIST_ASIDER_OPEN_STATE:
      new_state.isNewListAsiderOpen = action.payload;
      return new_state;
    case GLOBAL_ACTION.OPEN_ARTICLE_SIDEBAR_PREVIEW_IN_DETAIL_PROFILE:
      new_state.articleSidebarPreviewInDetailProfile = true;
      return new_state;
    case GLOBAL_ACTION.CLOSE_ARTICLE_SIDEBAR_PREVIEW_IN_DETAIL_PROFILE:
      new_state.articleSidebarPreviewInDetailProfile = false;
      return new_state;
    case GLOBAL_ACTION.DETAIL_PROFILE_SCROLL_CHECK:
      new_state.detailProfileScrollCheck = !new_state.detailProfileScrollCheck;
      return new_state;
    case GLOBAL_ACTION.ARTICLE_DIV_SCROLL_CHECK:
      new_state.articleDivScrollCheck = !new_state.articleDivScrollCheck;
      return new_state;
    case GLOBAL_ACTION.CLOSE_ADVANCED_SEARCH_SIDEBAR:
      new_state.showAdvancedSearchSidebar = false;
      return new_state;
    case GLOBAL_ACTION.OPEN_ADVANCED_SEARCH_SIDEBAR:
      new_state.showAdvancedSearchSidebar = true;
      return new_state;
    case GLOBAL_ACTION.ADVANCED_SEARCH:
      new_state.advancedSearch = !new_state.advancedSearch;
      return new_state;
    case GLOBAL_ACTION.ADVANCED_SEARCH_CHECK:
      new_state.advancedSearchCheck = action.payload;
      sessionStorage.setItem('advancedSearchCheck', action.payload.toString());
      return new_state;
    case GLOBAL_ACTION.APPLY_AUDIENCE_FILTERS:
      new_state.applyAudienceFilterCheck = !new_state.applyAudienceFilterCheck;
      return new_state;
    case GLOBAL_ACTION.AUDIENCE_FILTERS_APPLIED:
      new_state.audienceFiltersApplied = action.payload;
      return new_state;
    case GLOBAL_ACTION.SET_SMALL_RESOLUTION_MODAL:
      new_state.smallResolutionModal = action.payload;
      return new_state;
    default:
      return state;
  }
};

export default uiReducer;
